import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap';
import i18n from '../locales/i18n';
import ServicesCard from './ServicesCard';
import '../style/style.css';

/* eslint no-underscore-dangle: 0 */

export default function Services({ servicesList }) {
  const { t } = useTranslation();
  const services = servicesList.sort((a, b) => Number(a.key) - Number(b.key));

  return (
    <div className="section services" id="servicos">
      <h2 className="title">{t('services')}</h2>
      <Accordion>
        {services.map((service) => (
          <ServicesCard
            key={service.key}
            evkey={service.key}
            image={service.image}
            title={service.title1[i18n.language]}
            description={service.description1[i18n.language]}
          />
        ))}
      </Accordion>
    </div>
  );
}

Services.propTypes = {
  servicesList: PropTypes.instanceOf(Array).isRequired,
};
